
const Cart = () => {
    return null;
}

export default Cart;
